import WebGLLine from '../primitives/WebGLLine';
import CompositeShape from '../CompositeShape';
import Shape from '../Shape';
import WebGLPoint from '../primitives/WebGLPoint';

export default class WebGLCartesianCoordinates extends CompositeShape {

	public constructor (private components: Shape[]) {
		super();
	}

	/*
	 * Factory methods
	 */

	public static create (x1: number, y1: number, x2: number, y2: number, xParts: number, yParts: number) {
		const xLength = x2 - x1;
		const yLength = y2 - y1;
		const xInterval = xLength / xParts;
		const yInterval = yLength / yParts;
		const stripeLength = 0.01;

		const components: Shape[] = [];
		components.push(new WebGLLine(x1, 0, x2, 0));
		for (let i = 1; i < xParts; i++) {
			const stripeDistance = x1 + i * xInterval;
			components.push(new WebGLLine(stripeDistance, -stripeLength, stripeDistance, stripeLength));
		}

		components.push(new WebGLLine(0, y1, 0, y2));
		for (let i = 1; i < yParts; i++) {
			const stripeDistance = y1 + i * yInterval;
			components.push(new WebGLLine(-stripeLength, stripeDistance, stripeLength, stripeDistance));
		}

		for (let i = 0; i < xParts + 1; i++) {
			const x = x1 + i * xInterval;
			for (let j = 0; j < yParts + 1; j++) {
				const y = y1 + j * yInterval;
				components.push(new WebGLPoint(x, y));
			}
		}

		return new WebGLCartesianCoordinates(components);
	}

	public copy () {
		return new WebGLCartesianCoordinates(this.components.map(component => component.copy()));
	}

	/*
	 * Protected methods
	 */

	public getComponents () {
		return this.components;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/composites/WebGLCartesianCoordinates.ts